import React, { useEffect, useRef } from 'react';
import { LoadScript } from '@react-google-maps/api';
//css
//Actions
//img

const LIBRARIES = ['places', 'geocoder'];

export default function MapWrapper(props) {
  return (
    <LoadScript
      googleMapsApiKey={'AIzaSyDvJ_qNNEL1p1bVvVGM2YjcBj8jPz3z2JU'}
      libraries={LIBRARIES}
    >
      {props.children}
    </LoadScript>
  );
}
